<template>
    <div class="form">
        <h4 class="step-title">
            What is your current deductible and liability?
        </h4>
        <div class="step-content d-flex flex-column align-items-center">
            <scrollable-button-list v-bind:items="deductibleAndLiabilities" v-bind:onclick="complete" v-bind:value="lead.homeInsurance.currentDeductible + ',' + lead.homeInsurance.currentLiability"/>
        </div>
    </div>
</template>

<script>
    import ScrollableButtonList from "../shared/ScrollableButtonList.vue"

    export default {
        name: "CurrentHomeDeductibleAndLiability",
        components: {
            ScrollableButtonList
        },
        data: function() {
            return {
                deductibleAndLiabilities: [
                    { text: "$500 / $500,000", value: "500,500000" },
                    { text: "$1,000 / $1,000,000", value: "1000,1000000" },
                    { text: "$10,000 / $10,000,000", value: "10000,10000000" }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
            complete: function(value) {
                var valueParts = value.split(",");
                this.lead.homeInsurance.currentDeductible = valueParts[0];
                this.lead.homeInsurance.currentLiability = valueParts[1];
                this.$emit("complete", this.$options.name, value.deductible + ", " + value.liability);
            }
        }
    }
</script>
